<template>
  <div>
    <b-breadcrumb>
      <b-breadcrumb-item to="/">
        <i class="fa fa-home"></i>
        Home
      </b-breadcrumb-item>
      <b-breadcrumb-item to="/idts">Interdepartmental Transfers</b-breadcrumb-item>
      <b-breadcrumb-item to="/idts">{{ type }} IDTs</b-breadcrumb-item>
      <b-breadcrumb-item active>Add Network IDT</b-breadcrumb-item>
    </b-breadcrumb>

    <form @submit.prevent="onSubmit()">
      <div class="card">
        <div class="bg-dark card-header text-white">Add New {{ type }} IDT</div>
        <div class="card-body">
          <div class="row">
           <b-col col lg="3" md="4" class="form-group">
                <label for="accountId">Account</label>
                <select class="form-control" v-model="accountId">
                    <option :value="null" disabled>--Select Account--</option>
                    <option :key="account.id" :value="account.id" v-for="account in accounts">{{account.sl}}-{{account.sa}}</option>
                </select>
            </b-col>
            <b-col col lg="3" md="4" class="form-group">
                <label for="updateOrganizationId">Department</label>
                <select class="form-control" v-model="organizationId">
                    <option :value="null" disabled>--Select Department--</option>
                    <option :key="organization.id" :value="organization.id" v-for="organization in organizations">{{ organization.code }}</option>
                </select>
            </b-col>
            <div class="col form-group">
                <label for="description">Description</label>
                <input class="form-control"
                        v-model="description"/>
            </div>
            <div class="col-md-4 col-sm-12 form-group">
              <label for="amountCharged">Amount Charged</label>
              <input class="form-control" v-model="amountCharged" placeholder="Amount Charged" />
            </div>
          </div>
        </div>

        <div class="card-footer d-print-none text-right">
          <button :disabled="isSubmitting" class="btn btn-primary" type="submit">Submit</button>
          <RouterLink :to="{ name: 'IDTs' }" class="btn btn-danger">Back</RouterLink>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import InterdepartmentalTransfersService from "@/services/InterdepartmentalTransfersService";
import { ToastType } from '@/services/models/shared/ToastType';
import AccountsService from '@/services/AccountsService';
import OrganizationService from '@/services/OrganizationService';

export default {
  props: {
    type: {
      type: String,
      required: true
    },
    fiscalPeriodIDTNumberId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      accounts: [],
      organizations: [],
      isSubmitting: false,
      accountId: null,
      organizationId: null,
      amountCharged: null,
      description: null
    };
  },
  methods: {
    onSubmit() {
      const vm = this;

      vm.isSubmitting = true;
      InterdepartmentalTransfersService.addIDT({
        fiscalPeriodIDTNumberId: this.fiscalPeriodIDTNumberId,
        accountId: this.accountId,
        organizationId: this.organizationId,
        description: this.description,
        amountCharged: this.amountCharged
      })
        .then(() => {
          vm.alert(ToastType.Success, `The ${vm.type} IDT was successfully created.`);
          vm.$router.replace({ name: 'IDTs' });
        })
        .catch((error) => {
          vm.alert(ToastType.Danger, error.response.statusText);
        })
        .finally(() => {
          vm.isSubmitting = false;
        });
    },
    
    loadAccounts () {
      const vm = this;

      AccountsService.getAccounts({
        returnAll: true,
        page: 1,
        pageSize: 10,
        isDeleted: false
      })
          .then(response => {
              vm.accounts = response.data;
          })
          .catch(error => {
              vm.alert(ToastType.Danger, error.response.data)
          })
    },

    loadOrganizations () {
      const vm = this;

      OrganizationService.getOrganizationList({
        onlyShowActive: true,
        returnAll: true
      })
          .then(response => {
              vm.organizations = response.data;
          })
          .catch(error => {
              vm.alert(ToastType.Danger, error.response.data)
          })
    },
  },
  created() {
    this.loadAccounts();
    this.loadOrganizations();
  }
};
</script>